import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { AuthComponent } from './auth.component';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { PrimengModule } from '../primeng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ForogtPasswordComponent } from './forogt-password/forogt-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ToastControllerService } from 'src/app/pages/services/toast-controller.service';

@NgModule({
  declarations: [AuthComponent, LoginComponent, ForogtPasswordComponent, ResetPasswordComponent],
  exports: [AuthComponent, LoginComponent, ForogtPasswordComponent, ResetPasswordComponent],
  imports: [CommonModule, RouterModule, PrimengModule, FormsModule, ReactiveFormsModule],
  providers: [MessageService, ToastControllerService, DatePipe],
})
export class AuthModule {}
